export const CREATE_SUBSCRIPTION_TOUR = {
  id: "create_subscription",
  steps: [
    {
      element: '[data-tour="sub-plan"]',
      popover: {
        title: "Selecione o plano",
        description: "Escolha o plano que este cliente vai assinar.",
        side: "bottom",
      },
    },
    {
      element: '[data-tour="sub-type"]',
      popover: {
        title: "Tipo de assinatura",
        description:
          '"Com pagamento" cobra imediatamente via gateway. "Teste grátis" dá um período sem cobrança.',
        side: "bottom",
      },
    },
    {
      element: '[data-tour="sub-extras"]',
      popover: {
        title: "Créditos extras",
        description:
          "Use os botões + e − para ajustar pacotes extras. O valor total atualiza automaticamente.",
        side: "top",
      },
    },
    {
      element: '[data-tour="sub-summary"]',
      popover: {
        title: "Resumo",
        description:
          "Confira o valor total antes de confirmar. Base + extras = total mensal.",
        side: "top",
      },
    },
  ],
};
